import React, { useReducer, useContext, useEffect } from 'react';
import querystring from 'querystring';
import { useHabitat } from '@js/react/shared/HabitatContext';
const reducerFn = (state, action) => {
    switch (action.type) {
        case 'SET_EMPLOYEES': {
            return {
                ...state,
                employers: action.payload,
            };
        }
        case 'SET_PRODUCTS': {
            return {
                ...state,
                products: action.payload,
            };
        }
        case 'SET_SUBMITTED': {
            return {
                ...state,
                hasSubmitted: action.payload,
            };
        }
        case 'SET_SELECTED_EMPLOYEE': {
            const fields = {
                fullName: '',
                employerName: action.payload?.searchValue ?? '',
                emailAddress: '',
                contactNumber: '',
                marketing: false,
            };
            if (action.payload.product?.name) {
                fields[action.payload.product.name.replace(/\s/g, '')] = true;
            }
            return {
                ...state,
                hasSelectedEmployer: true,
                selectedEmployer: action.payload?.employer,
                isValidEmployer: action.payload?.employer !== undefined,
                productError: action.payload?.productError ?? false,
                employerNotFound: action.payload?.employerNotFound ?? false,
                fieldData: { fields: fields },
                searchValue: action.payload?.searchValue ?? '',
                hasSubmitted: false,
            };
        }
        case 'SET_FIELD_DATA': {
            return {
                ...state,
                fieldData: action.payload,
            };
        }
        case 'SET_ACCESS_TOKEN': {
            return {
                ...state,
                accessToken: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
const initialState = {
    employers: [],
    fieldData: {
        fields: {
            employerName: '',
            fullName: '',
            emailAddress: '',
            contactNumber: '',
            marketing: false,
        },
    },
    hasSelectedEmployer: false,
    hasSubmitted: false,
    isValidEmployer: false,
    productError: false,
    products: [],
    searchValue: '',
    accessToken: '',
};
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const EligibilityContext = React.createContext(undefined);
export const EligibilityProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducerFn, initialState);
    const { culturecode } = useHabitat();
    const query = {
        culturecode,
    };
    useEffect(() => {
        if (culturecode === 'uk') {
            getToken();
        }
        async function getToken() {
            const token = await fetchAccessToken();
            dispatch({
                type: 'SET_ACCESS_TOKEN',
                payload: token,
            });
        }
    }, []);
    useEffect(() => {
        if (culturecode === 'us') {
            getData();
        }
        async function getData() {
            const res = await fetch(`/umbraco/api/employersapi/getallemployers?${querystring.stringify(query)}`, {
                headers: { accept: 'application/json' },
            });
            if (!res.ok) {
                return;
            }
            const response = (await res.json());
            dispatch({
                type: 'SET_EMPLOYEES',
                payload: response,
            });
        }
    }, []);
    useEffect(() => {
        getData();
        async function getData() {
            const res = await fetch(`/umbraco/api/productsapi/getallproducts?${querystring.stringify(query)}`, {
                headers: { accept: 'application/json' },
            });
            if (!res.ok) {
                return;
            }
            const response = (await res.json());
            dispatch({
                type: 'SET_PRODUCTS',
                payload: response,
            });
        }
    }, []);
    return (React.createElement(EligibilityContext.Provider, { value: [state, dispatch] }, children));
};
export function useEligibilityContext() {
    return useContext(EligibilityContext);
}
export async function fetchAccessToken() {
    const res = await fetch(`/umbraco/api/employerssearchapi/auth/`, {
        headers: { accept: 'application/json' },
    });
    if (!res.ok) {
        return '';
    }
    const response = (await res.json());
    return response.access_token || '';
}
